export enum PublicPensionContractStatus {
  Active = "ACTIVE",
  EarnedPensionRight = "EARNED_PENSION_RIGHT",
  Payout = "PAYOUT",
}
